import { EventoCliente } from "features/cliente/clienteConstants";
import { DateUtils } from "shared/dateUtils";
import {
  NotificationItem,
  NotificationType,
  SuspendedClient,
} from "../notification.types";

export function isValidPendencyDate(operationDate?: number | null): boolean {
  if (operationDate == null) {
    return false;
  }

  return DateUtils.parse(operationDate).isValid();
}

function toSuspendedClient(client: unknown): SuspendedClient | null {
  if (typeof client !== "object" || client == null) {
    return null;
  }

  if (
    "StatusEvento" in client &&
    "StatusDataCriacao" in client &&
    "NomeReduzido" in client &&
    "IdCliente" in client
  ) {
    return {
      id: client.IdCliente as number,
      name: client.NomeReduzido as string,
      eventDate: client.StatusDataCriacao as string | null,
      event: client.StatusEvento as keyof typeof EventoCliente,
    } satisfies SuspendedClient;
  }

  return null;
}

export function getSuspendedClients(clients: unknown[]): SuspendedClient[] {
  if (!Array.isArray(clients)) {
    return [];
  }

  return clients
    .map((item) => toSuspendedClient(item))
    .filter(
      (client): client is SuspendedClient =>
        client !== null && client.event === EventoCliente.SUSPENSAO,
    );
}

export function getNotificationsCount(
  items: NotificationItem[],
  pendencyOperationDate: number | null,
  viewedNotifications: string[],
): number {
  return items.reduce((prev, current) => {
    if (current.type === NotificationType.PendingMovements) {
      return prev + 1;
    }

    if (
      current.type === NotificationType.ClientAccess &&
      !viewedNotifications.includes(current.id)
    ) {
      return prev + 1;
    }

    return prev;
  }, 0);
}
